import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { Company } from 'Interfaces/User';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: Company) =>
    $actions.user.updateCompanyInfo(dispatch, payload),
  );
};
